/* eslint-disable no-console */
import { useRouter } from 'next/router'

import { useEventBufferFlush } from '~/behavior-tracking/hooks/useEventBufferFlush'
import usePageVisitTracker from '~/behavior-tracking/hooks/usePageVisitTracker'
import useTestPrepGrade from '~/behavior-tracking/hooks/useTestPrepGrade'
import usePageVisibilityTracker from '~/behavior-tracking/hooks/usePageVisibilityTracker'
import usePageLeaveTracker from '~/behavior-tracking/hooks/usePageLeaveTracker'
import usePageUnloadTracker from '~/behavior-tracking/hooks/usePageUnloadTracker'
import useUserPulseTracker, { Presence } from '~/behavior-tracking/hooks/useUserPulseTracker'
import useStoredEventCleanUp from '~/behavior-tracking/hooks/useStoredEventCleanUp'
import { useAppSelector } from '~/redux/hooks'
import { selectUserId } from '~/auth/slices/auth.slice'
import { useVideoWatchTracker } from '~/behavior-tracking/hooks/useVideoWatchTracker'

export function useViewTracking(): Presence {
  const router = useRouter()
  const userId = useAppSelector(selectUserId)
  // ⚠ On a Test Prep test, every page event names the test's grade: time there counts toward it.
  const testPrepGrade = useTestPrepGrade(router.pathname)

  usePageVisitTracker(router, userId, testPrepGrade)
  usePageVisibilityTracker(router, userId, testPrepGrade)
  usePageLeaveTracker(router, userId, testPrepGrade)
  usePageUnloadTracker(router, userId, testPrepGrade)
  const presence = useUserPulseTracker(router, userId, testPrepGrade)
  useVideoWatchTracker(router, userId)

  useEventBufferFlush(userId)
  useStoredEventCleanUp(userId)

  return presence
}
